(function () {
    'use strict';

    angular
        .module('searchModule')
        .controller('SearchResultsController', Controller);

    Controller.$inject = ['$scope', '$state', 'historyCtxtService'];

    function Controller($scope, $state, historyCtxtService) {

        // Show more type results
        $scope.showMoreTypeResults = function (searchResultsGroup) {
            if (searchResultsGroup.ShowMoreResultsCount === 0) { return; }

            var goToNextPage = searchResultsGroup.maxDisplayedResults === $scope.searchResultsCtx.maxDisplayedResults;

            if ($scope.hierarchicalFacetCtx.currentLevel.instanceFacetId ===
                    $scope.hierarchicalFacetCtx.rootInstanceId) {
                // Focus on the current type
                var hierarchicalFacet =
                        _.find($scope.hierarchicalFacetCtx.facets, { ColumnValue: searchResultsGroup.ItemTypeCode });

                $scope.updateHierarchicalFacetContext(hierarchicalFacet.InstanceHierarchicalFacetID);
            }

            searchResultsGroup = $scope.searchCtx.resultsByType[0];
            searchResultsGroup.DisplayedItems = _.take(searchResultsGroup.Items, searchResultsGroup.maxDisplayedResults);
            searchResultsGroup.paginationPages = _.chunk(searchResultsGroup.Items, searchResultsGroup.maxDisplayedResults);
            searchResultsGroup.paginationPageIdx       = 0;
            searchResultsGroup.paginationStartResultNb = 1;
            searchResultsGroup.paginationEndResultNb = searchResultsGroup.DisplayedItems.length;

            if (goToNextPage) {
                $scope.showNextTypeResultsPage(searchResultsGroup);
            }
        };

        // Is Previous type results page disabled
        $scope.isPreviousTypeResultsPageDisabled = function (searchResultsGroup) {
            if (searchResultsGroup.paginationPageIdx === 0) { return true; }
        };

        // Show previous type results page
        $scope.showPreviousTypeResultsPage = function (searchResultsGroup) {
            if ($scope.isPreviousTypeResultsPageDisabled(searchResultsGroup)) { return; }

            searchResultsGroup.paginationPageIdx -= 1;
            searchResultsGroup.DisplayedItems =
                searchResultsGroup.paginationPages[searchResultsGroup.paginationPageIdx];

            searchResultsGroup.paginationStartResultNb =
                searchResultsGroup.maxDisplayedResults * searchResultsGroup.paginationPageIdx + 1;
            searchResultsGroup.paginationEndResultNb =
                searchResultsGroup.paginationStartResultNb + searchResultsGroup.DisplayedItems.length - 1;
        };

        // Is next type results page disabled
        $scope.isNextTypeResultsPageDisabled = function (searchResultsGroup) {
            if (searchResultsGroup.paginationPageIdx === (searchResultsGroup.paginationPages.length - 1)) {
                return true;
            }
        };

        // Show next type results page
        $scope.showNextTypeResultsPage = function (searchResultsGroup) {
            if ($scope.isNextTypeResultsPageDisabled(searchResultsGroup)) { return; }

            searchResultsGroup.paginationPageIdx += 1;
            searchResultsGroup.DisplayedItems =
                searchResultsGroup.paginationPages[searchResultsGroup.paginationPageIdx];

            searchResultsGroup.paginationStartResultNb =
               searchResultsGroup.maxDisplayedResults * searchResultsGroup.paginationPageIdx + 1;
            searchResultsGroup.paginationEndResultNb =
                searchResultsGroup.paginationStartResultNb + searchResultsGroup.DisplayedItems.length - 1;
        };

        // Is Psp employee refinable
        $scope.isPspEmployeeRefinable = function (pspEmp) {
            var refineByPerson = _.find($scope.refineFacetCtx.byRefineFacetId, { RefineFacetID: 2014 }); // Person: 2014

            if (_.isUndefined(refineByPerson)) { return false; }
            
            return _.some(refineByPerson.RefineFacetsByColumnValue, { ColumnValue: pspEmp.DisplayName });
        };

        // Refine By PSP employee
        $scope.refineByPspEmp = function (pspEmp, $event) {
            $event.preventDefault();

            if (!$scope.isPspEmployeeRefinable(pspEmp)) { return; }

            var personRefineFacetID = 2014;
            $scope.toggleRefineFacetSelection(personRefineFacetID, pspEmp.DisplayName);
        };

        // Go To Risk
        $scope.goToRisk = function (item) {
            historyCtxtService.goToState('riskEdit',
                { RiskID: item.RiskID },
                $state.current.name
            );
        };

        // Go To Control
        $scope.goToControl = function (item) {
            historyCtxtService.goToState('control',
                { ControlID: item.ControlID },
                $state.current.name
            );
        };

        // Go To ActionPlan
        $scope.goToActionPlan = function (item) {
            historyCtxtService.goToState('recommendation.edit.actionPlan.edit', {
                    RecommendationID: item.RecommendationID,
                    ActionPlanID: item.ActionPlanID
                },
                $state.current.name
            );
        };

        // Go To Recommendation
        $scope.goToRecommendation = function (item) {
            historyCtxtService.goToState('recommendation.edit',
                { RecommendationID: item.RecommendationID },
                $state.current.name
            );
        };

        // Go To Observation
        $scope.goToObservation = function (item) {
            historyCtxtService.goToState('observation.edit',
                { ObservationID: item.ObservationID },
                $state.current.name
            )
        };

        // Go To Risk Event
        $scope.goToRiskEvent = function (item) {
            historyCtxtService.goToState('riskEventEdit',
                { RiskEventID: item.RiskEventID },
                $state.current.name
            );
        };

        // Go to Plan Initiative
        $scope.goToPlanInitiative = function (item) {
            historyCtxtService.goToState('initiative.edit',
                { InitiativeID: item.PlanInitiativeID },
                $state.current.name
            );
        };

        // Go to Procedure
        $scope.goToProcedure = function (item) {
            historyCtxtService.goToState('procedure.view', {
                    ProcedureType: item.MetadataBlock.ProcedureType.Value,
                    ProcedureCode: item.MetadataBlock.ProcedureCode.Code
                },
                $state.current.name
            );
        };
    }
})();